import React, { lazy } from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { FadeUp } from '../ui/FadeUp';
const bonuses = [{
  title: 'Diagnóstico Express: ¿Es mío o lo absorbí?',
  description: 'Guía práctica para distinguir lo que te pertenece de lo que absorbiste.',
  image: 'https://cdn.magicpatterns.com/uploads/3zWVdZaag3zoCoB64tEkCS/bono_1.webp',
  alt: 'Mockup del Diagnóstico Express en tablet y libro'
}, {
  title: 'Audio "Botón de Reinicio" (7 min)',
  description: 'Audio breve para recuperar tu eje después de momentos intensos.',
  image: 'https://cdn.magicpatterns.com/uploads/8gKgKEhUVEbNo7h5TRihih/bono_2.webp',
  alt: 'Mockup del audio Botón de Reinicio en celular'
}, {
  title: 'Guía de Límites Energéticos Cotidianos',
  description: 'Herramientas concretas para dejar de absorber sin cerrarte.',
  image: 'https://cdn.magicpatterns.com/uploads/uMzQscFJtjD4R4yU1DMtXE/bono_3.webp',
  alt: 'Mockup de la Guía de Límites Energéticos en tablet y libro'
}, {
  title: 'Ritual Diario de 5 Minutos',
  description: 'Práctica simple para empezar el día centrada y sostenida.',
  image: 'https://cdn.magicpatterns.com/uploads/nMm3YHdXScxDTu6dDWEjjQ/bono_4.webp',
  alt: 'Mockup del Ritual Diario en celular'
}, {
  title: 'Cierre Energético Semanal',
  description: 'Proceso guiado para evitar acumulación emocional semana a semana.',
  image: 'https://cdn.magicpatterns.com/uploads/4vLPdQTuX8EMRerUTMSRo6/bono_5.webp',
  alt: 'Mockup del Cierre Energético Semanal en tablet'
}];
export function BonusesSection() {
  return <SectionWrapper bgColor="ivory" id="bonos" data-id="element-1">
      <FadeUp data-id="element-2">
        <p className="text-[10px] tracking-[0.15em] uppercase text-plum font-medium mb-1 text-center" data-id="element-3">
          Incluido en el Sistema ProMind Energy™
        </p>
        <p className="text-[10px] tracking-[0.1em] uppercase text-border-custom text-center mb-3" data-id="element-4">
          Edición limitada
        </p>
        <h2 className="text-[clamp(28px,8vw,40px)] text-center mb-10" data-id="element-5">
          5 bonos exclusivos
          <br data-id="element-6" />
          por lanzamiento
        </h2>
      </FadeUp>

      <div className="space-y-3" data-id="element-7">
        {bonuses.map((bonus, index) => <FadeUp key={index} delay={index * 0.1} data-id="element-8">
            <div className="bg-white rounded-[10px] p-[22px_20px] flex gap-4 items-start shadow-[0_1px_12px_rgba(0,0,0,0.04)] border border-black/5" data-id="element-9">
              <div className="font-serif text-[32px] font-light text-border-custom leading-none min-w-[28px] flex-shrink-0" data-id="element-10">
                {index + 1}
              </div>
              <div data-id="element-11">
                <h3 className="font-serif text-[20px] font-medium text-charcoal mb-1 leading-[1.2]" data-id="element-12">
                  {bonus.title}
                </h3>
                <p className="text-[12px] text-muted leading-[1.5] mb-3" data-id="element-13">
                  {bonus.description}
                </p>
                <div className="aspect-[3/2] w-full overflow-hidden rounded-[6px] bg-sand mt-3" data-id="element-14">
                  <img src={bonus.image} alt={bonus.alt} loading="lazy" className="w-full h-full object-cover" data-id="element-15" />
                </div>
              </div>
            </div>
          </FadeUp>)}
      </div>
    </SectionWrapper>;
}